window.LinkedChartSetup = {
	setupEditPanel: function (contentElement) {
		LinkedChartSetup.bindDdls();
		LinkedChartSetup.SetLinkedChartSettings(contentElement);
	},

	bindDdls: function () {

		$("#ddlLinkedChartProject").change(function () {
			LinkedChartSetup.getReportList();
			LinkedChartSetup.clearDdl("#ddlLinkedChartChart");
		});
		$("#ddlLinkedChartReport").change(function () {
			LinkedChartSetup.getChartList();
		});
	},

	getProjectList: function (val) {
		Helpers.performJSonCall2('GetProjectListForLinkedChart'
		, null
		, function (res) {
			LinkedChartSetup.setDdl(res, "#ddlLinkedChartProject", true);
			if (val) {
				LinkedChartSetup.setDdlValue(val, "#ddlLinkedChartProject");
			}
		}
		, null
		, 'Getting Project List...');
	},

	getReportList: function (val, databaseName) {
		Helpers.performJSonCall2('GetReportListForLinkedChart'
			, { databaseName: databaseName == null ? $("#ddlLinkedChartProject")[0].value : databaseName }
			, function (res) {
				LinkedChartSetup.setDdl(res, "#ddlLinkedChartReport", true);
				if (val) {
					LinkedChartSetup.setDdlValue(val, "#ddlLinkedChartReport");
				}
			}
			, null
			, 'Getting Report List...');
	},

	getChartList: function (val, databaseName, reportId) {
		Helpers.performJSonCall2('GetChartListForLinkedChart'
			, { databaseName: databaseName == null ? $("#ddlLinkedChartProject")[0].value : databaseName, reportId: reportId == null ? $("#ddlLinkedChartReport")[0].value : reportId }
			, function (res) {
				LinkedChartSetup.setDdl(res, "#ddlLinkedChartChart", false);
				if (val) {
					LinkedChartSetup.setDdlValue(val, "#ddlLinkedChartChart");
				}
			}
			, null
			, 'Getting Chart List...');
	},

	SetLinkedChartSettings: function (contentElement) {
		Helpers.performJSonCall2('GetLinkedChartSettings'
			, { contentElement: contentElement }
			, function (res) {
				if (res) {
					LinkedChartSetup.getProjectList(res.databaseName);
					LinkedChartSetup.getReportList(res.reportId, res.databaseName);
					LinkedChartSetup.getChartList(res.chartId, res.databaseName, res.reportId);
				}
				else {
					LinkedChartSetup.getProjectList();
					LinkedChartSetup.clearDdl("#ddlLinkedChartReport");
					LinkedChartSetup.clearDdl("#ddlLinkedChartChart");
				}
			});
	},

	setDdl: function (res, ddlSelector, addEmpty) {
		var ddl = $(ddlSelector)[0];
		ddl.innerHTML = "";
		if (addEmpty) {
			var optionEmpty = document.createElement("option");
			optionEmpty.value = "";
			optionEmpty.text = "";
			ddl.appendChild(optionEmpty);
		}
		for (var i = 0; i < res.length; i++) {
			var option = document.createElement("option");
			option.value = res[i].Value;
			option.text = res[i].Text;
			ddl.appendChild(option);
		}
	},

	setDdlValue: function (value, ddlSelector) {
		var ddl = $(ddlSelector)[0];
		ddl.value = value;
	},

	clearDdl: function (ddlSelector) {
		var ddl = $(ddlSelector)[0];
		ddl.innerHTML = "";
	},

	saveMapping: function (layoutElement, callback) {
		Helpers.performJSonCall2('SaveLinkedChart'
			, { targetLayoutElement: layoutElement
			, sourceLayoutElementId: $("#ddlLinkedChartChart")[0].value, databaseName: $("#ddlLinkedChartProject")[0].value
			}
			, callback);
	},

	validateInput: function () {
		return $("#ddlLinkedChartChart")[0].value != "";
	}
};
